<template>
    <div>
        <b-card no-body class="b-r-3 dashboardCard">
            <b-list-group flush>
                <b-list-group-item>
                    <div class="dashboardHeader">
                        {{ !moreThanOneSponser ? $t("lbl_EMPBE_SponsorshipAdPackage") : $t("lbl_EMPBE_SponsorshipAdPackage")
                            + " - " + (index + 1) }}
                    </div>
                    <b-card-body body-class="p-y-25 p-x-0">
                        <b-card-text>
                            <h2 class="text-center f-36 Roboto font-weight-bold">
                                {{ packageName }}
                            </h2>
                            <div class="text-center f-12 font-weight-bold dashboard-info">
                                {{
                                    $t("lbl_EMPBE_EffectivePeriod").replace(ReplaceText_StartDate, DisplayDate(effectiveDate)).replace(ReplaceText_EndDate, DisplayDate(expiryDate))
                                }}
                            </div>
                        </b-card-text>
                    </b-card-body>
                </b-list-group-item>
                <b-list-group-item v-if="adCount>0">
                    <div class="dashboardHeader">
                        {{ $t('lbl_buyerform_status') }}
                    </div>
                    <div class="row mt-4 mb-3">
                        <div class="col-6 f-12 font-weight-bold dashboard-info">

                            {{ $t("lbl_EMPBE_NoAdItemsEntitled") }}
                        </div>
                        <div class="col-6">
                            <div class="font-weight-bold m-l-5 f-16">{{ adCount }}</div>
                            <div class="mt-2">
                                <span v-if="adApproveCount > 0" class="badge-success badge m-5 f-16">
                                    {{ adApproveCount }} {{ $t('lbl_EMPBE_isActivate') }}
                                </span>
                                <span v-if="adRejectCount > 0" class="badge-danger badge m-5 f-16">
                                    {{ adRejectCount }} {{ $t('lbl_EMPBE_Rejected') }}
                                </span>
                                <span v-if="adPendingCount > 0" class="badge-warning badge m-5 f-16">
                                    {{ adPendingCount }} {{ $t('lbl_EMPBE_Pending') }}
                                </span>
                                <span v-if="adNotSubmitCount > 0" class="badge-light badge m-5 f-16">
                                    {{ adNotSubmitCount }} {{ $t('lbl_EMPBE_NotSubmitYet') }}
                                </span>
                            </div>
                            <div class="m-l-5 mt-2 f-12 font-weight-bold dashboard-info">
                                {{ $t("lbl_EMPBE_LastUpdatedOn").replace(ReplaceText_LastUpdatedDate,
                                    DisplayDate(lastUpdateDate)) }}
                            </div>
                        </div>
                    </div>
                </b-list-group-item>

            </b-list-group>

            <b-collapse visible :id="'sponsorPackageCollapse' + index">
                <b-list-group flush>
                    <b-list-group-item class="p-0"></b-list-group-item>
                    <b-list-group-item v-if="EMPEntitlements.length > 0">
                        <div class="dashboardHeader">
                            {{ $t("lbl_EMPBE_EMPEntitlements") }}
                        </div>
                        <div class="dashboardEntitlement mb-3" v-for="(item) in EMPEntitlements">
                            <div class="mt-3 d-flex">
                                <i class="fa fa-check f-20"></i>
                                <div class="m-l-10">{{ langid == 1252 ? item.itemNameEN : langid == 936 ? item.itemNameSc :
                                    item.itemNameTC }}</div>
                            </div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item v-if="CPSEntitlements.length > 0">
                        <div class="dashboardHeader">
                            {{ $t("lbl_EMPBE_CPSOLEntitlements") }}
                        </div>
                        <div class="dashboardEntitlement mb-3" v-for="(item) in CPSEntitlements">
                            <div class="mt-3 d-flex">
                                <i class="fa fa-check f-20"></i>
                                <div class="m-l-10">{{ langid == 1252 ? item.itemNameEN : langid == 936 ? item.itemNameSc :
                                    item.itemNameTC }}</div>
                            </div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item v-if="OtherEntitlements.length > 0">
                        <div class="dashboardHeader">
                            {{ $t("lbl_EMPBE_OtherEntitlements") }}
                        </div>
                        <div class="dashboardEntitlement mb-3" v-for="(item) in OtherEntitlements">
                            <div class="mt-3 d-flex">
                                <i class="fa fa-check f-20"></i>
                                <div class="m-l-10">{{ langid == 1252 ? item.itemNameEN : langid == 936 ? item.itemNameSc :
                                    item.itemNameTC }}</div>
                            </div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
                <b-card-footer footer-class="b-t-light dashboardCardFoother">
                    <div class="d-flex align-items-center justify-content-center">
                        <b-button class="dashboard-btn" v-b-toggle="'MoreAboutSponsorship' + index"
                            v-bind:t_label="'EMPBE_Dashboard_MoreAboutSponsorship'" variant="outline-light">{{
                                $t('lbl_EMPBE_MoreAboutSponsorship') }}</b-button>
                    </div>
                </b-card-footer>
            </b-collapse>
            <div class="cardExpendButton dashboardCard">
                <feather type="chevron-down" @click="expend = !expend" v-if="!expend"
                    v-b-toggle="'sponsorPackageCollapse' + index"></feather>
                <feather type="chevron-up" @click="expend = !expend" v-if="expend"
                    v-b-toggle="'sponsorPackageCollapse' + index"></feather>
            </div>
        </b-card>

        <b-sidebar backdrop :id="'MoreAboutSponsorship' + index"
            :title='index <= 0 ? $t("lbl_EMPBE_SponosrPackage ") : $t("lbl_EMPBE_SponsorshipAdPackage")' right
            bg-variant="grey" :shadow="true">
            <div class="tab-pane active p-20">
                <img :src="imagePath" class="w-100" />
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import { userService } from '../../../_services'
var defaultDatetimeString = '0001-01-01 00:00:00'

export default {
    props: ["data", "index", "moreThanOneSponser"],
    data() {
        return {
            expend: true,
            membershipExpiryDate: '',
            adExpiryDate: '',
            lastSubmitDate: '',
            isExpiremembershipExpiryDate: this.membershipExpiryDate < new Date(),
            isExpireadExpiryDate: this.adExpiryDate < new Date(),
            isExpirelastSubmitDate: this.lastSubmitDate < new Date(),
            ReplaceText_LastUpdatedDate: '{{LastUpdatedDate}}',
            ReplaceText_StartDate: '{{StartDate}}',
            ReplaceText_EndDate: '{{EndDate}}',
        }
    },
    computed: {
        langid() {
            return localStorage.getItem("currentLangId")
        },
        imagePath() {
            var langPath = this.langid == 1252 ? "en" : "cn";
            return 'https://cdn.adsalecdn.com/EMP/Backend/Images/Dashboard/' + this.data[0].packageGroup + '_' + langPath + '.jpg'
        },
        packageName() {
            return this.langid == 1252 ? this.data[0].packageNameEN : this.langid == 950 ? this.data[0].packageNameTC : this.data[0].packageNameSC;
        },
        effectiveDate() {
            return this.data[0].adPackageId ? this.data[0]?.effectiveDateFrom : this.data[1]?.effectiveDateFrom;
        },
        expiryDate() {
            return this.data[0].adPackageId ? this.data[0]?.effectiveDateTo : this.data[1]?.effectiveDateTo;
        },
        adCount() {
            return this.data.filter(x => x.isAdPlacement && (x.adDetailId??0) > 0).length;
        },
        adApproveCount() {
            return this.data.filter(x => x.isAdPlacement && x.statusCode == 'A' && (x.adDetailId??0) > 0).length;
        },
        adPendingCount() {
            return this.data.filter(x => x.isAdPlacement && (x.statusCode == 'P' || x.statusCode == 'PA') && (x.adDetailId??0) > 0).length;
        },
        adNotSubmitCount() {
            return this.data.filter(x => {
                if (!x.isAdPlacement || (x.adDetailId ?? 0) <= 0) return false;
                const code = x.statusCode;
                return code == null || code === '' || code === 'N';
            }).length;
        },
        adRejectCount() {
            return this.data.filter(x => x.isAdPlacement && x.statusCode == 'R' && (x.adDetailId??0) > 0).length;
        },
        lastUpdateDate() {
            return this.data.reduce((a, b) => (a.updatedDate > b.updatedDate ? a : b)).updatedDate;
        },
        entitlements() {
            // Distinct
            const result = [];
            const map = new Map();
            for (const item of this.data) {
                if (!map.has(item.permissionHeaderType)) {
                    map.set(item.permissionHeaderType, true);    // set any value to Map
                    result.push(item);
                }
            }
            return result
        },
        EMPEntitlements() {
            return this.entitlements.filter(x => x.platformType == 'EMP')
        },
        CPSEntitlements() {
            return this.entitlements.filter(x => x.platformType == 'CPSOL')
        },
        OtherEntitlements() {
            return this.entitlements.filter(x => x.platformType == null)
        },
    },
    mounted() {

    },
    methods: {
        DisplayDate(dateStr) {
            if(dateStr == null) return ""
            var date = new Date(dateStr)
            try {
                var mm = date.getMonth() + 1; // getMonth() is zero-based
                var dd = date.getDate();

                return [date.getFullYear() + "-",
                (mm > 9 ? '' : '0') + mm + "-",
                (dd > 9 ? '' : '0') + dd
                ].join('');
            } catch (ex) {
                return "";
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dashboardCard {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25) !important;
    border-radius: 16px !important;
}
.card > .list-group:first-child {
    border-top-width: 0;
    border-radius: 16px !important;
}
</style>